export default "__VITE_ASSET__7ce3cf1f__"